import { useReducer } from "react";
import api from '../../../../../api/quiz';

const tempquiztypes  = [
  {id: 1, name: "Анкетирование"},
  {id: 2, name: "Тестирование"}
];

const islist = [
  {id:1, name: "Конструктор ОП"},
  {id:2, name: "База данных ЦОПП"},
];

const intialState = {
  quizTypes: [],
  programsList: [],
  isList: []
};

function reducer(state, action) {
  switch (action.type) {
    case "QUIZ_TYPES":
      return {
        ...state,
        quizTypes: action.quizTypes
      };
    case "PROGRAMS_LIST":
      return {
        ...state,
        programsList: action.programsList
      };
    case "IS_LIST":
      return {
        ...state,
        isList: action.isList
      };
    default:
      return {
        ...state
      };
  }
}

export default function useConnectForm() {
  const [dataSources, dispatch] = useReducer(reducer, intialState);

  function getQuizTypesList() {
    /*api.getQuizStates().then(({ data }) => {
      dispatch({ type: "QUIZ_STATES", quizStates: data });
    });*/
    dispatch({ type: "QUIZ_TYPES", quizTypes: tempquiztypes });
  }

  function getProgramsList() {
    /*api.getQuizStates().then(({ data }) => {
      dispatch({ type: "QUIZ_STATES", quizStates: data });
    });*/
    dispatch({ type: "PROGRAMS_LIST", programsList: [] });
  }

  function getIsList() {
    /*api.getQuizStates().then(({ data }) => {
      dispatch({ type: "QUIZ_STATES", quizStates: data });
    });*/
    dispatch({ type: "IS_LIST", isList: islist });
  }

  return {
    dataSources,
    getQuizTypesList,
    getProgramsList,
    getIsList
  };
}
